import { Link } from "react-router-dom";
import '../styles/licenceTypes.css';
import { licences, quoteLink } from "../data/licences";

const LicenseTypes = () => {
    return(
        <section id="licences" className="km-section km-section--alt LicenseContainer">
            <div className="km-container">
                <div className="km-sectionHead km-sectionHead--center" data-reveal>
                    <p className="km-eyebrow">Our services</p>
                    <h2 className="km-title">SAHPRA Licensing Services</h2>
                    <p className="km-lead">Three licence types, one team to guide you from application to approval.</p>
                </div>
                <div className="km-cardRow">
                    {licences.map((licence, index) => (
                        <article
                            className="km-card licenseCard"
                            key={licence.id}
                            data-reveal
                            style={{ "--reveal-order": index } as React.CSSProperties}
                        >
                            <img src={licence.img} alt={licence.imgAlt} className="licence-img" />
                            <h3>{licence.title}</h3>
                            <p className="licence-audience">{licence.audience}</p>
                            <p className="licence-summary">{licence.summary}</p>
                            <Link className="km-btn km-btn--primary km-btn--block" to={quoteLink(licence.id)}>
                                Request a Quote <span className="km-arrow" aria-hidden="true">→</span>
                            </Link>
                        </article>
                    ))}
                </div>
                <p className="licence-more">
                    <Link className="km-link" to="/service">Compare the licences in detail →</Link>
                </p>
            </div>
        </section>
    );
};

export default LicenseTypes;
